import React from 'react'

export const PHONE_CHROME_HINT =
    'Open the link in Google Chrome for the best camera support.'

export const ChromeNote = ({ style }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 8,

            padding: '9px 11px',

            borderRadius: 8,

            background: '#f7f8fa',

            color: '#686875',

            fontSize: 12,

            lineHeight: 1.4,

            ...style,
        }}
    >
        <span
            style={{
                flex: '0 0 auto',

                width: 16,
                height: 16,

                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

                borderRadius: '50%',

                background: '#e9ebef',

                color: '#777985',

                fontSize: 10,

                fontWeight: 700,

                marginTop: 1,
            }}
        >
            i
        </span>

        <span>
            {PHONE_CHROME_HINT}
        </span>
    </div>
)

export default ChromeNote